<!-- @format -->

<fudis-dialog *transloco="let t">
  <fudis-dialog-content>
    <fudis-form [titleVariant]="'lg'" [title]="t('TIMELINE.TIME_COURSE_UNIT.TITLE')" [level]="1">
      <fudis-form-content class="fudis-pb-xxl">
        <fudis-body-text class="fudis-mb-sm">
          {{ t("TIMELINE.TIME_COURSE_UNIT.DESCRIPTION") }}
        </fudis-body-text>

        <fudis-expandable
          [title]="t('TIMELINE.TIME_COURSE_UNIT.INFO_EXPANDABLE_1.TITLE')"
          [level]="2"
          [variant]="'lite'"
          [padding]="'small'">
          <ng-template fudisExpandableContent class="fudis-mb-none">
            <ul>
              <li>{{ t("TIMELINE.TIME_COURSE_UNIT.INFO_EXPANDABLE_1.INFO_1") }}</li>
              <li>{{ t("TIMELINE.TIME_COURSE_UNIT.INFO_EXPANDABLE_1.INFO_2") }}</li>
            </ul>
          </ng-template>
        </fudis-expandable>
        <fudis-expandable
          [title]="t('TIMELINE.TIME_COURSE_UNIT.INFO_EXPANDABLE_2.TITLE')"
          [level]="2"
          [variant]="'lite'"
          [padding]="'small'">
          <ng-template fudisExpandableContent>
            <ul>
              <li>{{ t("TIMELINE.TIME_COURSE_UNIT.INFO_EXPANDABLE_2.INFO_1") }}</li>
              <li>{{ t("TIMELINE.TIME_COURSE_UNIT.INFO_EXPANDABLE_2.INFO_2") }}</li>
            </ul>
          </ng-template>
        </fudis-expandable>

        <fudis-grid [columns]="1" [rowGap]="'md'">
          @if (untimedStudySelectOptions$ | async; as studySelectOptions) {
            <fudis-select
              [label]="t('ENTITY_NAMES.courseUnit')"
              [control]="form.controls.courseUnit"
              [variant]="'autocompleteDropdown'"
              [placeholder]="t('TIMELINE.TIME_COURSE_UNIT.SEARCH_PLACEHOLDER')">
              <ng-template fudisSelectOptions>
                @for (group of studySelectOptions; track group.id) {
                  <fudis-select-group [label]="group.label">
                    @for (option of group.options; track option) {
                      <fudis-select-option [data]="option" />
                    }
                  </fudis-select-group>
                }
              </ng-template>
            </fudis-select>
          }

          @if (studyPeriodsByTerm$ | async; as termGroups) {
            <fudis-multiselect
              [label]="t('TIMELINE.TIME_COURSE_UNIT.PERIOD_LABEL')"
              [control]="form.controls.studyPeriods"
              [variant]="'autocompleteDropdown'"
              [placeholder]="t('TIMELINE.TIME_COURSE_UNIT.SELECT')"
              [selectionClearButton]="false">
              <ng-template fudisSelectOptions>
                @for (termGroup of termGroups; track termGroup.id) {
                  <fudis-multiselect-group [label]="termGroup.label">
                    @for (periodOption of termGroup.options; track periodOption) {
                      <fudis-multiselect-option [data]="periodOption" />
                    }
                  </fudis-multiselect-group>
                }
              </ng-template>
            </fudis-multiselect>
          }
        </fudis-grid>
      </fudis-form-content>
      <fudis-form-actions>
        <fudis-button fudisDialogClose [variant]="'secondary'" [label]="t('SIS_COMPONENTS.BUTTON.CANCEL')" />
        <fudis-button fudisFormSubmit [formValid]="form.valid" (handleClick)="save()" [label]="t('SIS_COMPONENTS.BUTTON.SAVE')" />
      </fudis-form-actions>
    </fudis-form>
  </fudis-dialog-content>
</fudis-dialog>
